module.exports = __webpack_public_path__ + "static/media/Pega1.6910f773.png";